export const GET_TYPES_REQUEST = "GET_TYPES_REQUEST";
export const SAVE_ATTR = 'SAVE_ATTR'
export const INSERT_TYPE = 'INSERT_TYPE'
export const DELETE_TYPE = 'DELETE_TYPE'